import { ExendedOpcuaConfig } from '../shared/models/station/extended-opcua-config';

export class ModalDeleteConfigData {
    type: 'opcua' | 'gir';
    config: ExendedOpcuaConfig | any;
    stationUid: string;
}
